import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';

export default function DemenagementParisPage() {
  useEffect(() => {
    document.title = "Déménagement Paris | Aide au Déménagement & Chargement - Transporteur Express IDF";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF : aide au déménagement Paris, aide au chargement, location camion utilitaire avec chauffeur, déménageur professionnel pas cher. Devis gratuit 24/7 !');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'déménagement Paris, aide au déménagement Paris, aide au chargement Paris, location camion déménagement Paris, utilitaire avec chauffeur Paris, déménageur professionnel Paris, déménagement pas cher Paris, déménagement express Paris, porteur déménagement Paris, manutentionnaire Paris, camion déménagement, déménagement appartement Paris, déménagement bureau Paris, déménagement studio Paris, transporteur déménagement Paris');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://transporteurexpressidf.fr/demenagement-paris');
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Déménagement Paris | Aide au Déménagement & Chargement - Transporteur Express IDF');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Transporteur Express IDF : aide au déménagement Paris, aide au chargement, location camion utilitaire avec chauffeur, déménageur professionnel pas cher. Devis gratuit 24/7 !');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://transporteurexpressidf.fr/demenagement-paris');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="demenagement" />
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-20 pb-16">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-5xl font-black text-gray-900 mb-6 font-inter">
                Déménagement Paris Professionnel
              </h1>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                <strong>Déménagement Paris</strong> rapide et sécurisé avec notre équipe de <strong>déménageurs professionnels</strong>. Service <strong>déménagement pas cher</strong> pour appartement, bureau, maison dans tout Paris et Île-de-France. <strong>Déménagement Paris</strong> avec devis gratuit et intervention rapide.
              </p>
            </div>
            
            <div className="text-center">
              <a 
                href="tel:+33632410246"
                className="inline-flex items-center px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line w-5 h-5 mr-3"></i>
                Devis Gratuit +33 6 32 41 02 46
              </a>
            </div>
          </div>
        </section>

        {/* Mini Price Simulator */}
        <MiniPriceSimulator />

        {/* Services Déménagement */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Services Déménagement Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-home-4-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Appartement</h3>
                <p className="text-gray-600 mb-4">
                  Déménagement appartement Paris avec déménageurs expérimentés. Déménagement studio, T2, T3, T4 et plus grandes surfaces avec matériel professionnel.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Déménagement studio Paris</li>
                  <li>• Déménagement T2, T3, T4</li>
                  <li>• Emballage professionnel</li>
                  <li>• Démontage/remontage meubles</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-building-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Bureau</h3>
                <p className="text-gray-600 mb-4">
                  Déménagement bureau Paris professionnel. Déménagement entreprise, cabinet, bureau avec transport sécurisé du matériel informatique et mobilier.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Déménagement entreprise</li>
                  <li>• Transport matériel informatique</li>
                  <li>• Déménagement cabinet médical</li>
                  <li>• Planning sur mesure</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-time-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Express</h3>
                <p className="text-gray-600 mb-4">
                  Déménagement express Paris en urgence. Déménagement rapide dans la journée pour situations urgentes avec équipe disponible immédiatement.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Déménagement urgence</li>
                  <li>• Intervention rapide</li>
                  <li>• Déménagement jour J</li>
                  <li>• Équipe disponible 24/7</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-money-euro-circle-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Pas Cher</h3>
                <p className="text-gray-600 mb-4">
                  Déménagement pas cher Paris avec tarifs transparents. Déménagement économique sans compromis sur la qualité avec devis gratuit détaillé.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Tarifs compétitifs</li>
                  <li>• Déménagement économique</li>
                  <li>• Sans frais cachés</li>
                  <li>• Devis gratuit</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Transport Volumineux</h3>
                <p className="text-gray-600 mb-4">
                  Transport volumineux Paris pour gros mobilier. Déménagement piano, électroménager, mobilier lourd avec matériel de manutention adapté.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Déménagement piano</li>
                  <li>• Transport électroménager</li>
                  <li>• Mobilier lourd</li>
                  <li>• Matériel spécialisé</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Sécurisé</h3>
                <p className="text-gray-600 mb-4">
                  Déménagement sécurisé Paris avec assurance. Protection complète de vos biens, emballage professionnel et déménageurs formés.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Assurance déménagement</li>
                  <li>• Emballage sécurisé</li>
                  <li>• Déménageurs formés</li>
                  <li>• Matériel de protection</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Zones Déménagement */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Zones de Déménagement Paris
            </h2>
            
            <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Ouest</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Déménagement Paris 16ème</li>
                  <li>• Déménagement Paris 7ème</li>
                  <li>• Déménagement Boulogne</li>
                  <li>• Déménagement Neuilly</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Est</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Déménagement Paris 11ème</li>
                  <li>• Déménagement Paris 12ème</li>
                  <li>• Déménagement Vincennes</li>
                  <li>• Déménagement Montreuil</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Nord</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Déménagement Paris 17ème</li>
                  <li>• Déménagement Paris 18ème</li>
                  <li>• Déménagement Clichy</li>
                  <li>• Déménagement Levallois</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3">Paris Sud</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Déménagement Paris 13ème</li>
                  <li>• Déménagement Paris 14ème</li>
                  <li>• Déménagement Issy</li>
                  <li>• Déménagement Vanves</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Prix Déménagement */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Tarifs Déménagement Paris
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <h3 className="text-2xl font-bold mb-4">Déménagement Studio</h3>
                <div className="text-4xl font-bold text-blue-600 mb-4">À partir de 199€</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• 2 déménageurs</li>
                  <li>• Utilitaire équipé</li>
                  <li>• Matériel inclus</li>
                  <li>• Devis gratuit</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
                >
                  Réserver
                </a>
              </div>

              <div className="bg-blue-600 p-8 rounded-2xl shadow-lg text-white text-center relative">
                <div className="absolute top-4 right-4 bg-yellow-400 text-blue-600 px-3 py-1 rounded-full text-sm font-bold">
                  POPULAIRE
                </div>
                <h3 className="text-2xl font-bold mb-4">Déménagement Appartement</h3>
                <div className="text-4xl font-bold mb-4">À partir de 399€</div>
                <ul className="space-y-2 mb-6">
                  <li>• 3 déménageurs</li>
                  <li>• Camion 20m³</li>
                  <li>• Emballage inclus</li>
                  <li>• Assurance</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
                >
                  Réserver
                </a>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <h3 className="text-2xl font-bold mb-4">Déménagement Maison</h3>
                <div className="text-4xl font-bold text-blue-600 mb-4">Sur devis</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• Équipe dédiée</li>
                  <li>• Gros camion</li>
                  <li>• Service complet</li>
                  <li>• Devis personnalisé</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
                >
                  Devis gratuit
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Déménagement */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Questions Fréquentes Déménagement
            </h2>
            
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Combien coûte un déménagement Paris ?</h3>
                <p className="text-gray-600">
                  Le prix déménagement Paris dépend de la taille du logement. Déménagement studio dès 199€, appartement dès 399€. Devis déménagement gratuit par téléphone.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Fournissez-vous le matériel de déménagement ?</h3>
                <p className="text-gray-600">
                  Oui, nous fournissons tout le matériel : cartons, papier bulle, sangles, diable, film plastique. Matériel de déménagement professionnel inclus.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Êtes-vous assurés pour le déménagement ?</h3>
                <p className="text-gray-600">
                  Absolument, nous avons une assurance déménagement complète. Vos biens sont protégés pendant tout le transport et la manutention.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Pouvez-vous déménager un piano ?</h3>
                <p className="text-gray-600">
                  Oui, nous sommes spécialisés dans le déménagement piano Paris. Équipe formée et matériel adapté pour transport piano en toute sécurité.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Final */}
        <section className="py-20 bg-blue-600 text-white">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Prêt pour votre Déménagement Paris ?
            </h2>
            <p className="text-xl mb-8 opacity-90">
              Devis gratuit et intervention rapide - Appelez maintenant !
            </p>
            <a 
              href="tel:+33632410246"
              className="inline-flex items-center px-8 py-4 bg-white text-blue-600 text-lg font-semibold rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-5 h-5 mr-3"></i>
              +33 6 32 41 02 46
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
}